module.exports = __webpack_public_path__ + "static/img/renting.8d49aab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/renting.jpg
// module id = qqcT
// module chunks = 1